import React from "react";
import { useIsMobile } from "../hooks/is.mobile";
import "../css/image.grid.css";

interface ImageStripProps {
  images: any[];
  clickable?: boolean;
}

export const ClickableImageGrid: React.FC<ImageStripProps> = ({
  images,
  clickable,
}) => {
  const isMobile = useIsMobile();

  return (
    <div className="image-grid">
      {images.map((src: any, i: number) => (
        <div className="image-grid-item" key={i}>
          <img
            onClick={
              clickable
                ? () => {
                    const fileName = src.split("/").pop().split(".")[0]; // only gets "GATES"
                    const targetUrl = `https://vertexhorizons.gumroad.com/l/${fileName}?layout=profile`;
                    window.open(targetUrl, "_blank");
                  }
                : () => {}
            }
            src={src}
            alt={`Image ${i}`}
          />
        </div>
      ))}
    </div>
  );
};
